<template>
    <div>
        <PageTitle :title="$t('baja.titulo')"/>
        <FirstBanner/>
        <section class="padding-vertical-content">
            <div class="container">
                <div class="row" v-if="!baja">
                    <div class="col-12 text-center">
                        <p>
                            {{ $t('baja.recuerda') }}
                            <br/>
                            {{ $t('baja.no_vuelta') }}
                        </p>
                    </div>
                    <div class="col-12 text-center">
                        <div class="row justify-content-center">
                            <div class="col-12 col-md-6 col-lg-4 mb-3">
                                <FormCaptchaComponent
                                    ref="captcha"
                                    :siteKey="sitekey"
                                    @success="onCaptchaVerified"
                                    @expired="invalidateCaptcha"
                                    @error="invalidateCaptcha"
                                />
                            </div>
                        </div>
                        <button
                            v-if="!loading"
                            class="button large-button sitecolor-content"
                            data-cy="baja-submit"
                            :disabled="!canSubmit"
                            @click="handleDarDeBaja"
                        >
                            {{ $t('baja.dar_baja') }}
                        </button>
                        <Skeleton v-else padding="tw:p-0" variant="" customClass="tw:inline-flex tw:h-12 tw:w-40">
                            <template #skeleton>
                                <SkeletonItem customClass="tw:w-full" height="tw:h-12"/>
                            </template>
                        </Skeleton>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-12 text-center">
                        <h2>
                            {{ $t('baja.nos_vemos') }}
                        </h2>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
    import { ref, getCurrentInstance } from 'vue';
    import { useRoute } from '@/composables/common/router/useRouter';
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FirstBanner from '@/components/frontend/shared/FirstBanner';
    import { useHead } from '@/composables/common/seo/useHead';
    import { useBajaEmails } from '@/composables/front/contact/useBajaEmails';
    import FormCaptchaComponent from '@/modules/ui/FormCaptchaComponent.vue';
    import { Skeleton, SkeletonItem } from '@/modules/front/ui/skeleton';

    const route = useRoute();

    useHead('Baja emails');

    const captcha = ref(null);

    const {
        baja,
        loading,
        sitekey,
        canSubmit,
        onCaptchaVerified,
        onCaptchaInvalid,
        clearCaptcha,
        darDeBaja
    } = useBajaEmails(route.query.email);

    const instance = getCurrentInstance();

    /**
     * Turnstile tokens are single-use and can expire or hard-fail while the
     * user is still on the page. Every invalidation must hand out a fresh
     * challenge or the form becomes unsubmittable. The widget's message
     * explains WHY the token was invalidated, so it is preserved: reset and
     * feedback are separate concerns.
     */
    const invalidateCaptcha = () => {
        onCaptchaInvalid();
        captcha.value?.reset({ keepFeedback: true });
    };

    /**
     * Full reset, used after a failed attempt: the backend has consumed the
     * token, so the user must solve a brand new challenge.
     */
    const resetCaptcha = () => {
        clearCaptcha();
        captcha.value?.reset();
    };

    const handleDarDeBaja = async() => {
        const { ok } = await darDeBaja();

        if (!ok) {
            resetCaptcha();
            instance.proxy.$toast.error(instance.proxy.$t('baja.error_envio'));
        }
    };
</script>
